export const enumStudentStatus = {
    0: "CreatingAccount",
    1: "Active",
    2: "Disabled",
    3: "Archived",
    4: "Invited"
}